export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';
export const INCREASE_UNREAD_COUNT = 'INCREASE_UNREAD_COUNT';
export const SET_LAST_MESSAGE = 'SET_LAST_MESSAGE';
